import { DatalayerService } from '@analytics/datalayer';
import { inject, Injectable } from '@angular/core';
import { type CONSENT_LEVEL_VALUES } from '@core/consent';

@Injectable({
  providedIn: 'root',
})
export class ConsentAnalyticsService {
  readonly #datalayer = inject(DatalayerService);

  /**
   * Dispatches an event to the analytics layer signalling that the cookie statement is visible.
   */
  public sendImpressionBeacon() {
    this.#datalayer.pushEvent({
      event: 'cookiestatement-impression',
      info: {},
    });
  }

  /**
   * Dispatches an event to the analytics layer signalling that cookie settings have been submitted.
   * @param allowTrackingCookies whether or not tracking cookies are allowed - adjusts the payload going to the analytics layer.
   */
  public sendSubmissionBeacon(consentLevel: CONSENT_LEVEL_VALUES) {
    this.#datalayer.pushEvent({
      event: 'cookiestatement-click',
      info: {
        level: consentLevel,
      },
    });
  }
}
